module.exports = __webpack_public_path__ + "media/images/icon-svg/person-outline-8e1b3ae579b7d65e744645dac26fa2e0.svg";